export default {
  setCardTransactions(state, { list, page }) {
    state.cardTransactions = list
    state.cardPage = page
  },
  resetCardTransactions(state) {
    state.cardTransactions = []
    state.cardPage = { page: 0, size: 10, totalPages: 0, totalElements: 0 }
  }
}
